import dateFns from 'date-fns';
import { prepareData } from 'app/components/pages/monitoring/patient-visits/table-week/PrepareData';

const TEMPLATE_NAME = 'PATIENT_WEEK_VISITS';

const formatData = data => {
    return data.map(elem => {
        let { start: startVisit, end: endVisit, arrivalDate } = elem

        const doesStartVisitExist = !!startVisit
        const doesEndVisitExist = !!endVisit

        if (doesStartVisitExist && !doesEndVisitExist) {
            endVisit = startVisit
        }

        if (!doesStartVisitExist && doesEndVisitExist) {
            startVisit = endVisit
        }

        const hours = dateFns.getHours(new Date(arrivalDate))
        const minutes = dateFns.getHours(new Date(arrivalDate))
        const arrivalTimeIsMidnight = hours === 0 && minutes === 0

        if (arrivalTimeIsMidnight) {

            arrivalDate = dateFns.addSeconds(new Date(arrivalDate), 1)

        } else {

            arrivalDate = new Date(arrivalDate)

        }

        return {
            ...elem,
            start: doesStartVisitExist? dateFns.addSeconds(new Date(startVisit), 1) : dateFns.addSeconds(new Date(arrivalDate), 1),
            end: doesEndVisitExist ? dateFns.addSeconds(new Date(endVisit), 1) : dateFns.addSeconds(new Date(arrivalDate), 1)
        }
    })
}

const initialState = () => ({
    loading: false,
    data: []
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${TEMPLATE_NAME}_FULFILLED`: {
            const data = action.payload;
            const preparedData = prepareData(data.resume)

            return {
                ...state,
                loading: false,
                data: formatData(preparedData)
            };
        }
        case `${TEMPLATE_NAME}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};

export default reducer;
